var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInscritosFonasa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.6 65",
    style: {
      enableBackground: "new 0 0 92.6 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00A99D;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#008B81;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-36.116 -88.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_446713592",
    transform: "translate(35.274 39.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_259927288",
    className: "st0",
    d: "M62.7,98.9C62.7,98.9,62.7,98.8,62.7,98.9C62.7,98.8,62.7,98.8,62.7,98.9v-1.7 c0-7.3-5.1-13.7-12.2-15.4c-2.5,1-5.3,1-7.8,0c-7.1,1.7-12.2,8.1-12.2,15.4v3.9h32.2V98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259926664",
    className: "st1",
    d: "M77,79.1c-1.3,0-2.6-0.2-3.9-0.7c-4.9,1.2-9,4.7-11,9.4c1.8,2.8,2.7,6.1,2.7,9.4v0.5h28.2 v-3.9c0-7.3-5.1-13.7-12.2-15.4C79.7,78.9,78.4,79.1,77,79.1L77,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259927192",
    className: "st0",
    d: "M77,59.6c-4.8,0-8.6,3.9-8.6,8.6s3.9,8.6,8.6,8.6c4.8,0,8.6-3.9,8.6-8.6 C85.7,63.5,81.8,59.6,77,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259926568",
    className: "st1",
    d: "M17.3,79.1c-1.3,0-2.6-0.2-3.9-0.7C6.3,80.1,1.3,86.5,1.2,93.8v3.9h27.1v-0.5 c0-3.8,1.2-7.4,3.4-10.5c-2.1-4.2-6-7.2-10.5-8.3C19.9,78.9,18.6,79.1,17.3,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259925824",
    className: "st0",
    d: "M17.3,59.6c-4.8,0-8.6,3.9-8.6,8.6c0,4.8,3.9,8.6,8.6,8.6c4.8,0,8.6-3.9,8.6-8.6 C25.9,63.5,22.1,59.6,17.3,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_446713064",
    className: "st1",
    d: "M46.6,63c-4.8,0-8.6,3.9-8.6,8.6c0,4.8,3.9,8.6,8.6,8.6c4.8,0,8.6-3.9,8.6-8.6c0,0,0,0,0,0 C55.2,66.8,51.3,63,46.6,63z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInscritosFonasa);
export default __webpack_public_path__ + "static/media/icon-inscritos-fonasa.d2d2cc29a6b52e6536c7329b9b0a483d.svg";
export { ForwardRef as ReactComponent };